import { billing } from '@transfeeradev/api-enums';
const invoiceStatus = billing.invoiceStatus;

export default {
  [invoiceStatus.PAID]: 'blue',
  [invoiceStatus.OPEN]: 'yellow',
  [invoiceStatus.OVERDUE]: 'red',
  [invoiceStatus.PROTESTED]: 'red'
};
